<template>
  <div>
    <div class="page-bar" style="margin-bottom:10px;">
      <ul class="page-breadcrumb">
          <li>
              <router-link :to="{name:'compare'}">Comparaison</router-link>
          </li>
      </ul>
    </div>

    <div class="row" v-if="quizzes && quizzesPublished > 0">
      <div class="col-xs-5 mb-10">
        <select class="form-control input-lg" v-model="quiz1">
            <option v-for="quiz in quizzes" :value="quiz.slug" v-if="quiz.state == 'published'">{{quiz.title}}</option>
        </select>
      </div>
      <div class="col-xs-2 text-center">
        <router-link v-if="quiz1" :to="{name:'quizzes_responses',params:{slug:quiz1}}" class="btn btn-default text-right btn-circle btn_table btn_perso float-left mt-10"><i class="icon-eye"></i></router-link>
        <h1 class="m-0" style="display:inline;">Vs</h1>
        <router-link v-if="quiz2" :to="{name:'quizzes_responses',params:{slug:quiz2}}" class="btn btn-default text-right btn-circle btn_table btn_perso float-right mt-10"><i class="icon-eye"></i></router-link>
      </div>
      <div class="col-xs-5 mb-10">
        <select class="form-control input-lg" v-model="quiz2">
          <option v-for="quiz in quizzes" :value="quiz.slug" v-if="quiz.state == 'published'">{{quiz.title}}</option>
        </select>
      </div>

      <div class="col-md-6" v-if="quiz1">
        <responses :quizSlug='quiz1' :number="1"></responses>
      </div>
      <div class="col-md-6 text-center" v-else>
        <h3>Choisissez un questionnaire.</h3>
      </div>

      <div class="col-md-6" v-if="quiz2">
        <responses :quizSlug='quiz2' :number="2"></responses>
      </div>
      <div class="col-md-6 text-center" v-else>
        <h3>Choisissez un questionnaire.</h3>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-xs-12 col-md-6 col-md-offset-3">
        <div class="note note-warning mt-30">
          <h4 class="block"> Avertissement</h4>
          <p> Vous devez créer au moins un questionnaire pour pouvoir effectuer une comparaison.</p>
        </div>
        <router-link :to="{name:'quizzes_create'}" class="btn btn-circle yellow"><i class="fa fa-plus"></i>
             Créer un questionnaire
        </router-link>

      </div>
    </div>
  </div>
</template>

<script>
import quizzes from '../../requests/quizzes.js'
import storage from '../../storage/data.js'
// var config = require('../../config/settings.json');
import Responses from '../quizzes/responses'

export default {
  name: 'compare',
  components:{
    Responses
  },
  data () {
    return{
      quizzes:[],
      quiz1:'',
      quiz2:''
    }
  },
  computed:{
    quizzesPublished:function(){
      // Renvoyer uniquement le nb de quiz publié.
      var countPublished = 0;
      this.quizzes.forEach(function(quiz){
        if(quiz.state == "published"){
          countPublished++;
        }
      })
      return countPublished;
    }
  },
  mounted:function(){
    var parent = this;
    if(storage.data.user.role == "dev"){
      quizzes.getAll(this,function(quizzes,error){
        if(quizzes){
          parent.quizzes = quizzes;
        }
        else{
          toastr.error("ERREUR dans la récupération des questionnaires.");
        }
      });
    }
    else{
      quizzes.getAllMyQuizzes(this,function(quizzes,error){
        if(quizzes){
          parent.quizzes = quizzes;
        }
        else{
          toastr.error("ERREUR dans la récupération des questionnaires.");
        }
      });
    }
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>



// WEBPACK FOOTER //
// compare.vue?1a37b2d9